module.exports = __webpack_public_path__ + "img/ymkjbanner4.a47a6f28.png";